import type {V2RecipientPayoutConfirmationSummary} from '@stripe-internal/ark';

import {ConnectElementObservableValues} from './ConnectElementObservableValues';

export type FetchEphemeralKeyResponse = {
  issuingCard: string;
  nonce: string;
  ephemeralKeySecret: string;
};

export interface IConnectElementSupplementalFunction {
  // All items here should be functions that return promises and take in a single parameter

  // Internal
  fetchAdditionalPaymentPropsInternalDoNotUse?: (params: {
    paymentId: string;
  }) => Promise<string>;
  fetchAdditionalPaymentPropsInternalDoNotUse2?: (
    paymentId: string,
  ) => Promise<string>;
  callbackWithMultipleParams?: (
    taxCode: string,
    additionalParams: {additionalParam1: string},
  ) => void;
  onSetConfirmationSummary?: (
    summary?: V2RecipientPayoutConfirmationSummary,
  ) => void;
  onAttachPaymentMethodError?: (error: Error) => void;
  onLinkSignedUp?: (linkSignedUp: boolean) => void;
  onReturnToLanding?: () => void;

  // API reviewed
  // Preview
  fetchEphemeralKey?: (fetchParams: {
    issuingCard: string;
    nonce: string;
  }) => Promise<FetchEphemeralKeyResponse>;

  // Preview
  onTaxCodeSelect?: (
    taxCode: string | null,
    additionalParams: {analyticsName: string} | null,
  ) => void;

  handleCheckScanSubmitted?: (params: {
    checkScanToken: string;
  }) => Promise<void>;

  // GA
}

export type SupplementalFunctionKey = keyof IConnectElementSupplementalFunction;
export type SupplementalFunctionValue =
  Required<IConnectElementSupplementalFunction>[SupplementalFunctionKey];
export type SupplementalFunctionAwaitedReturnMap = {
  [K in SupplementalFunctionKey]: Awaited<
    ReturnType<Required<IConnectElementSupplementalFunction>[K]>
  >;
};
export class ConnectElementSupplementalFunctions extends ConnectElementObservableValues<IConnectElementSupplementalFunction> {}
